<template>
  <div class="AllBox">
    <van-sticky>
      <van-nav-bar
        left-arrow
        fixed
        safe-area-inset-top
        @click-left="onClickLeft"
      >
        <template #left>
          <div class="left-nr">
            <img src="../../assets/nav/yz_nav_fh.png" alt="" />
          </div>
        </template>
      </van-nav-bar>
    </van-sticky>

    <div class="mainBox">
      <ul>
        <li>
          <div class="gameBox">
            <van-skeleton title avatar :row="1" :loading="state.loading">
              <img :src="state.teamData.avatar" class="gameImg" />
            </van-skeleton>

            <h3>{{ state.teamData.name }}</h3>
            <img
              src="../../assets/chat/chat_authority01.png"
              alt=""
              class="authority"
            />
          </div>
        </li>
        <li class="groupRule" @click="goGroupPublicRule">
          <span>群规则</span>
          <img src="../../assets/chat/chat_group_go.png" alt="" />
        </li>
        <li>
          <div class="usersTitle" @click="goEditName(state.userID)">
            <span>群昵称</span>
            <img src="../../assets/chat/chat_group_go.png" alt="" />
          </div>
        </li>
      </ul>
    </div>
  </div>

  <!-- 群规则圆角弹窗（底部） -->
  <van-popup
    v-model:show="state.showBottom"
    round
    position="bottom"
    :style="{ height: '60%', background: '#2F3130' }"
  >
    <h1>群规则</h1>
    <ul>
      <li>
        1、请勿在群聊内刷屏、灌水、吵架、发布消极、涉黄涉政、脏话等言论以及图片，多开小号群聊扰乱正常聊天秩序，违者禁言，严重拉黑处理;
      </li>
      <li>
        2、请勿在群聊内发布私人联系方式、其他平台信息、收售平台币及线下出售平台账号，以及兜售其他非本平台的游戏号，违者禁言，严重拉黑处理;
      </li>
      <li>
        3、任何私下交易、联系请自行提高警惕，受骗则平台一概不负责;
      </li>
      <li>
        4、请勿对官方人员虚报情况骗取奖励，若造成恶劣影响的，将会被永久禁言或封禁游戏账号，如果查询到有利用平台规则进行牟利等非正常游戏操作,平台有权将账号下的余额进行回收或者封禁账号处理;
      </li>
      <li>
        5、请勿恶意对平台或游戏进行抹黑造谣等行为，如有违反将会永久禁言或封禁游戏账号;
      </li>
      <li>
        6、对有任何违反上述群规的行为，可长按信息进行举报，由管理员进行处理;
      </li>
      <li>
        7、游戏中遇到问题，可在app内点击右下角或游戏内悬浮窗更多里的“客服”联系在线客服处理，也可以@群管理进行反馈;
      </li>
      <li>
        8、如后续有规则修改将会直接同步在群规则内，将不再进行公告;
      </li>
    </ul>
  </van-popup>
</template>

<script>
import { onActivated, onDeactivated, reactive } from "vue";
import { useRouter } from "vue-router";
import SDK from "@yxim/nim-web-sdk";
import { useStore } from "vuex";
import { getQueryString } from "../../utils/location";
export default {
  name: "GroupSetting",
  setup() {
    const router = useRouter();
    // const route = useRoute();
    const store = useStore();
    const state = reactive({
      teamData: {},
      nim: null,
      userID: store.state.wyAccount,
    });

    //群规则
    const goGroupPublicRule = () => {
      // state.showBottom = true;
      router.push({
        path: "/GroupRules",
      });
    };
    const onClickLeft = () => {
      router.back();
    };
    //解散或退群

    const goEditName = (uid) => {
      router.push({
        path: "/GroupName",
        query: { uid: uid, name: state.nickInTeam, teamId: state.teamId },
      });
    };
    const getTeamDone = (error, obj) => {
      state.teamData = obj;
      state.allSilent = obj.mute;
      state.loading = false;
    };

    onActivated(() => {
      store.dispatch("getInfo");
      state.teamId = getQueryString("groupId");
      // window.scrollTo(0, 0);
      state.nim = SDK.NIM.getInstance({
        // 初始化SDK
        debug: false,
        appKey: store.state.appKey,
        account: store.state.wyAccount,
        token: store.state.wyToken,
        debugLevel: "debug",
        db: false,
      });
      setTimeout(() => {
        state.nim.getTeam({
          teamId: state.teamId,
          done: getTeamDone,
        });
      });
    });

    return {
      state,
      goGroupPublicRule,
      onClickLeft,
      goEditName,
      getTeamDone,
    };
  },
};
</script>

<style scoped="scoped">
:deep(.van-nav-bar__title) {
  color: #000;
}
.AllBox {
  background-color: rgb(0, 0, 0);
}
.van-nav-bar {
  background: rgba(0, 0, 0, 0);
}
.van-hairline--bottom::after {
  border: none;
}
.mainBox {
  height: 100vh;
  background-color: #161B1F;
  padding-top: 108px;
  overflow: hidden;
}

.mainBox ul li {
  background-color: #3f4951;
  margin: 0 24px 24px;
  padding: 23px;
  border-radius: 15px;
  color: #fff;
}
.mainBox ul li:nth-of-type(1) {
  height: 320px;
}

.mainBox ul li span {
  font-size: 26px;
  font-weight: bold;
  margin-left: 24px;
}

.mainBox ul li h3 {
  font-size: 26px;
  font-weight: bold;
  margin-top: 24px;
}

.gameBox {
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  justify-content: center;
}

.gameBox h3 {
  font-size: 32px !important;
}

.usersTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.usersTitle p {
  font-size: 28px;
  color: #999999;
}
.usersTitle div {
  display: flex;
  align-items: center;
}
.usersTitle img {
  width: 36px;
  height: 36px;
}

.usersList {
  text-align: center;
  font-size: 24px;
  /* background-color: #2a8dcb; */
}

.usersList ul {
  display: flex;
  background-color: #fff;
}

.usersList ul li {
  /* background-color: #d669d4; */
  margin: 6px;
  padding: 6px;
}

.usersList img {
  width: 88px;
  height: 88px;
  border-radius: 50%;
}

.usersList p {
  font-size: 22px;
  color: #666;
}

.gameImg {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  /* margin-left: 24px; */
}

.mainBox ul .actionP {
  text-align: center;
  border-radius: 198px;
  color: #ff6666;
}
.mainBox ul .groupRule {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.groupRule img {
  height: 36px;
  width: 36px;
}

/* 群规则弹窗 */
.van-popup {
  scroll-behavior: smooth;
}
.van-popup--bottom {
  padding: 40px 32px;
}
.van-popup--bottom h1 {
  font-size: 40px;
  /* margin-bottom: 32px; */
  color: #fff;
  font-weight: 500;
  margin: 40px 32px 32px 32px;
}
.van-popup--bottom ul li {
  color: #fff;
  font-size: 24px;
  font-weight: 500;
  margin: 5px 32px;
}
.authority {
  width: 64px;
  height: 64px;
  position: absolute;
  right: 210px;
  top: 136px;
}
.left-nr img {
  width: 60px;
  height: 60px;
  margin-top: 10px;
}

.van-overlay {
  background-color: aquamarine;
}

:deep(.van-skeleton__avatar) {
  width: 200px;
  height: 200px;
  margin-right: 0;
}
</style>
<style>
.dialog-overlay {
  background: rgba(0, 0, 0, 0.35);
}
</style>
